/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_CameraInputs */

const th_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กล้อง`)
};

const en_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera`)
};

const ja_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カメラ`)
};

const zh_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摄像头`)
};

const es_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cámara`)
};

const pt_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Câmera`)
};

const id_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera`)
};

const fr_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caméra`)
};

const tl_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera`)
};

const vi_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy ảnh`)
};

const ko_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카메라`)
};

const de_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera`)
};

const ru_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Камера`)
};

const tr_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera`)
};

const it_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotocamera`)
};

const pl_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera`)
};

const uk_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Камера`)
};

const hi_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैमरा`)
};

const ar_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكاميرا`)
};

const ms_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera`)
};

const bn_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যামেরা`)
};

const zh_tw2_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相機`)
};

const zh_hk2_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相機`)
};

const ur_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کیمرا`)
};

const fa_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوربین`)
};

const sw_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera`)
};

const nl_video_camera = /** @type {(inputs: Video_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera`)
};

/**
* | output |
* | --- |
* | "Camera" |
*
* @param {Video_CameraInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_camera = /** @type {((inputs?: Video_CameraInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_CameraInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_camera(inputs)
	if (locale === "ja") return ja_video_camera(inputs)
	if (locale === "zh") return zh_video_camera(inputs)
	if (locale === "es") return es_video_camera(inputs)
	if (locale === "pt") return pt_video_camera(inputs)
	if (locale === "id") return id_video_camera(inputs)
	if (locale === "fr") return fr_video_camera(inputs)
	if (locale === "tl") return tl_video_camera(inputs)
	if (locale === "vi") return vi_video_camera(inputs)
	if (locale === "ko") return ko_video_camera(inputs)
	if (locale === "de") return de_video_camera(inputs)
	if (locale === "ru") return ru_video_camera(inputs)
	if (locale === "tr") return tr_video_camera(inputs)
	if (locale === "it") return it_video_camera(inputs)
	if (locale === "pl") return pl_video_camera(inputs)
	if (locale === "uk") return uk_video_camera(inputs)
	if (locale === "hi") return hi_video_camera(inputs)
	if (locale === "ar") return ar_video_camera(inputs)
	if (locale === "ms") return ms_video_camera(inputs)
	if (locale === "bn") return bn_video_camera(inputs)
	if (locale === "zh-TW") return zh_tw2_video_camera(inputs)
	if (locale === "zh-HK") return zh_hk2_video_camera(inputs)
	if (locale === "ur") return ur_video_camera(inputs)
	if (locale === "fa") return fa_video_camera(inputs)
	if (locale === "sw") return sw_video_camera(inputs)
	if (locale === "nl") return nl_video_camera(inputs)
	return en_video_camera(inputs)
});